module.exports = __webpack_public_path__ + "img/service-challenge-img.4739b276.png";